import { combineReducers } from '@reduxjs/toolkit';
import lessonDataReducer from './data';
import gameplaysReducer from './gameplays';
import phrasesReducer from './phrases';
import lessonPreviewReducer from './preview';
import lessonSelectors from './selectors';
import lessonSessionReducer from './session';
import lessonSessionResultsReducer from './sessionResults';

export * from './data';
export * from './gameplays';
export * from './phrases';
export * from './preview';
export * from './session';
export * from './sessionResults';
export { lessonSelectors };
export type { tLessonStore };

const lessonReducer = combineReducers({
  data: lessonDataReducer,
  session: lessonSessionReducer,
  phrases: phrasesReducer,
  gameplays: gameplaysReducer,
  sessionResults: lessonSessionResultsReducer,
  preview: lessonPreviewReducer
});

type tLessonStore = ReturnType<typeof lessonReducer>;

export default lessonReducer;
